// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import FormPageHeading from '../../common/molecule/FormPageHeading';
import BirthdaySavingsList from '../../common/organism/BirthdaySavingsList';
import internalEndpoints from '../../common/internalEndpoints';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import BirthdayModuleLabels, {
  ACCOUNT_PROFILE,
} from '../../BirthdayProductListing/views/BirthdayModule.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '../../../../../utils/labels/globalActions.labels';

export const BirthdaySavings = () => {
  const accountProfileLabels = getLabelFromCopyOrFromTranslation(
    ACCOUNT_PROFILE,
    BirthdayModuleLabels
  );
  return (
    <>
      <BodyCopy component="div" className="elem-mb-LRG">
        <Anchor
          to={internalEndpoints.profilePage.link}
          asPath={internalEndpoints.profilePage.path}
          fontSizeVariation="xlarge"
          anchorVariation="secondary"
          data-locator="backLink"
          useRouterNavigation
        >
          <span className="left-arrow" />
          {renderLabel(
            getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
              GlobalActionsLabels
            ),
            'lbl_back'
          )}
        </Anchor>
      </BodyCopy>
      <FormPageHeading
        className="elem-mb-XL myAccountRightView uppercaseHeader"
        heading={renderLabel(
          accountProfileLabels?.lbl_profile_birthday_savings,
          'lbl_profile_birthday_savings'
        )}
        data-locator="birthdaySavingsLbl"
      />
      <BirthdaySavingsList view="edit" />
    </>
  );
};

export default BirthdaySavings;
